import { useEffect } from 'react';
import { useAppDispatch } from '../../../store';
import { useValidateTokenMutation } from '../api/authApi';
import { authSelector, clearAuthResponse, setAuthResponse } from '../state/authSlice';
import { api } from '../../../api';
import { useSelector } from 'react-redux';

export const useCheckToken = () => {
  const { token } = useSelector(authSelector);
  const isAuthenticated = Boolean(token);
  const dispatch = useAppDispatch();
  const [validateToken, { isLoading, isUninitialized }] = useValidateTokenMutation();

  useEffect(() => {
    const checkLocalToken = async () => {
      if (isAuthenticated) return;
      const authInfo = localStorage.getItem('authInfo');

      if (authInfo) {
        const token = JSON.parse(authInfo).access;
        try {
          await validateToken({ token }).unwrap();
          dispatch(setAuthResponse(JSON.parse(authInfo)));
        } catch (err) {
          dispatch(api.util.resetApiState());
          dispatch(clearAuthResponse());
        }
      }
    };
    checkLocalToken();
  }, []);

  return { loadingToken: isLoading, isUninitialized };
};
